export const LOGIN_PATH = "/login";
export const PRICING_PATH = "/pricing";
export const INTERNAL_ERROR_PATH = "/internal-error";
export const ONBOARDING_DONE_PATH = "/onboarding-done";
export const BILLING_RETURN_PATH = "/billing/return";

/**
 * Paths where the user is expected to be unauthenticated, unsubscribed,
 * transitioning through logout, or viewing a global error page. API errors on
 * these routes should not trigger a redirect to /login (on 401), and
 * authenticated-only queries should stay paused while the user is here.
 */
export const AUTH_FREE_PATHS = [
  LOGIN_PATH,
  "/logout",
  "/logout-success",
  PRICING_PATH,
  INTERNAL_ERROR_PATH,
  "/auth/verify",
];

export function isAuthFreePath(pathname: string): boolean {
  return (
    AUTH_FREE_PATHS.includes(pathname) ||
    pathname === ONBOARDING_DONE_PATH ||
    pathname.startsWith(`${ONBOARDING_DONE_PATH}/`)
  );
}
